import { Component, computed, input } from '@angular/core';

import { ImageComponent } from '@valk-nx/components/ui-image/src/lib/image.component';
import type { ImageInterface } from '@valk-nx/components/ui-image/src/lib/image.interface';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';

@Component({
	selector: 'vp-image-slide',
	templateUrl: './image-slide.html',
	imports: [ImageComponent],
	host: { class: 'block h-full' },
})
export class ImageSlideComponent {
	readonly image = input.required<PhotoInterface>();
	readonly width = input.required<number>();
	readonly height = input.required<number>();
	readonly sizes = input<string>('auto, 100vw');
	readonly maxWidth = input<number | undefined>(undefined);

	readonly slideImage = computed<ImageInterface>(() => ({
		src: this.image().src,
		altText: this.image().alt,
		width: this.width(),
		height: this.height(),
	}));
}
